import { render, staticRenderFns } from "./TaskModal.vue?vue&type=template&id=194dd0bd&scoped=true&"
import script from "./TaskModal.vue?vue&type=script&lang=js&"
export * from "./TaskModal.vue?vue&type=script&lang=js&"
import style0 from "./TaskModal.vue?vue&type=style&index=0&id=194dd0bd&lang=scss&scoped=true&"
import style1 from "./TaskModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194dd0bd",
  null
  
)

export default component.exports